import React from 'react';
import styles from './styles.module.scss';
import { markdownToHtml } from '@/utils/markdown-to-html';

interface BodyMProps {
  text: string;
  maxLines?: number;
  className?: string;
  style?: React.CSSProperties;
}

export const BodyM: React.FC<BodyMProps> = ({
  text,
  maxLines = 10000,
  className = '',
  style,
}) => {
  const clampStyle: React.CSSProperties = {
    WebkitLineClamp: maxLines,
  };

  return (
    <div
      className={`${styles.bodyM} ${className}`}
      style={{ ...clampStyle, ...style }}
      dangerouslySetInnerHTML={{ __html: markdownToHtml(text) }}
    />
  );
};
